import { IWebviewState } from '../../types/reducers/webview';

export const defaultState: IWebviewState = {
  hostActionName: null,
};
